import Link from 'next/link';
import { BarChart2, Hash, TrendingUp, Users, Calendar } from 'lucide-react';
import styles from './index.module.less';
import React from 'react';
import { useTranslation } from 'next-i18next';
import { useRouter } from 'next/router';

export default function ExploreMoreToolsSection() {
  const { t } = useTranslation();
  const router = useRouter();

  const tools = [
    {
      title: t("See Trending Influencers' Instagram Activity"),
      description: t('Track recent follows and followers of top influencers'),
      icon: 'BarChart2',
      href: '/top-instagram',
    },
    {
      title: t('Anonymous Instagram Story Viewer'),
      description: t("View Instagram Stories Anonymously with Dolphin Radar's Free Viewer Tool"),
      icon: 'Hash',
      href: '/anonymous-instagram-story-viewer',
    },
    {
      title: t('Instagram Web Viewer'),
      description: t('Easily view Instagram profiles, posts with Dolphin Radar.'),
      icon: 'TrendingUp',
      href: '/instagram-viewer/post-comments',
    },
    {
      title: t('Hashtag Generator for Instagram'),
      description: t('Generate effective Instagram hashtags to boost engagement with Dolphin Radar'),
      icon: 'Users',
      href: '/instagram-hashtag-generator',
    },
    {
      title: t('Instagram Recent Follower Tracker'),
      description: t(
        'Instantly track recent Instagram follows with Dolphin Radar. See the latest followers of any account effortlessly.'
      ),
      img: '/images/dashboard/follow.svg',
      href: '/instagram-new-follow-tracker',
    },
  ];

  return (
    <section className={styles['explore-more-tools-section']}>
      <h2 className={styles.title}>{t('Explore More DolphinRadar Instagram Analysis Tools')}</h2>
      <div className={styles['tools-grid']}>
        <div
          className={styles['tool-card']}
          onClick={() => {
            router.push('/');
          }}
        >
          <div>
            <button className={styles['add-account-button']}>{t('Learn More')}</button>
          </div>
          <p className={styles['add-account-text']}>
            <span role="img" aria-label="Silver Bullet" className="mr-2">
              🎯
            </span>
            {t('Silver Bullet of IG activity tracking')}
          </p>
        </div>

        {tools.map((tool, index) => (
          <Link key={index} href={tool.href} className={styles['tool-card']}>
            <div className={styles['tool-header']}>
              <div className={styles['icon-container']}>
                {tool.icon ? (
                  React.createElement(
                    tool.icon === 'BarChart2'
                      ? BarChart2
                      : tool.icon === 'Hash'
                        ? Hash
                        : tool.icon === 'TrendingUp'
                          ? TrendingUp
                          : tool.icon === 'Users'
                            ? Users
                            : Calendar,
                    { className: styles.icon }
                  )
                ) : (
                  <img src={tool.img} alt={tool.title} className={styles.icon} />
                )}
              </div>
              <h3 className={styles['tool-title']}>{tool.title}</h3>
            </div>
            <p className={styles['tool-description']}>{tool.description}</p>
          </Link>
        ))}
      </div>
    </section>
  );
}
